import Loadable from 'app/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const FAQ = Loadable(lazy(() => import('../pages/faq/index')))

const faqRoutes: RouteObject[] = [
  {
    path: '/faq',
    element: <FAQ />,
  },
]

export default faqRoutes
